import React from 'react';
import { DatePicker, Form, Input, InputNumber, FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { RangePickerProps } from 'antd/es/date-picker';
import classes from '../InviteUsersModal.module.scss';

type CreateLinkFormValues = {
  invite_name: string;
  max_invites?: number;
  expires_at?: any;
};

type CreateLinkFormProps = {
  form: FormInstance;
  onFinish: (values: CreateLinkFormValues) => void;
};

const CreateLinkForm = ({ form, onFinish }: CreateLinkFormProps) => {
  const { t } = useTranslation();

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current && current < dayjs().subtract(1, 'day').endOf('day');
  };

  return (
    <Form
      form={form}
      layout='vertical'
      className={classes.createLinkForm}
      onFinish={onFinish}
    >
      <Form.Item
        label={t('Users.modals.invite.linkForm.nameLabel')}
        name='invite_name'
        rules={[
          { required: true, message: t('Users.modals.invite.linkForm.nameRequired') },
          { max: 100, message: t('Users.modals.invite.linkForm.nameMax') },
        ]}
      >
        <Input
          placeholder={t('Users.modals.invite.linkForm.namePlaceholder')}
          maxLength={100}
        />
      </Form.Item>

      <Form.Item
        label={t('Users.modals.invite.linkForm.maxInvitesLabel')}
        name='max_invites'
        rules={[
          { required: true, message: t('Users.modals.invite.linkForm.maxInvitesRequired') },
        ]}
      >
        <InputNumber
          min={1}
          max={100}
          placeholder={t('Users.modals.invite.linkForm.maxInvitesPlaceholder')}
          className={classes.createLinkFormInput}
        />
      </Form.Item>

      <Form.Item
        label={t('Users.modals.invite.linkForm.expiresAtLabel')}
        name='expires_at'
      >
        <DatePicker
          disabledDate={disabledDate}
          showTime
          format={'HH:mm DD-MM-YYYY'}
          placeholder={t('Users.modals.invite.linkForm.expiresAtPlaceholder')}
          className={classes.createLinkFormInput}
        />
      </Form.Item>
    </Form>
  );
};

export default CreateLinkForm;
